module.exports = __webpack_public_path__ + "img/towers.704df421.png";